import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PreviewAttachmentsViewComponent } from './preview-attachments-view/preview-attachments-view.component';
import { RoleGaurd } from 'src/app/shared/services/role-gaurd.service';

const routes: Routes = [
  {
    path: ':projectId/:fileName',
    component : PreviewAttachmentsViewComponent,
    data: {
      title: 'Preview Attachments',
    },
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PreviewAttachmentsRoutingModule { }
